import { useOnlineStatus } from '@/shared/hooks/useOnlineStatus';
import { IconNoInternet } from '@/shared/ui/icons';
import styles from './OfflineScreen.module.less';

export function OfflineScreen() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <div className={styles.iconWrap}>
          <IconNoInternet className={styles.icon} />
        </div>
        <h1 className={styles.title}>Нет подключения к интернету</h1>
        <p className={styles.subtitle}>
          Проверьте соединение и попробуйте снова
        </p>
      </div>
    </div>
  );
}
